import { createFileRoute } from "@tanstack/react-router"

import { loadIdentityReview } from "@/admin/identity-reviews/identity-review-data"
import { IdentityReviewPage } from "@/admin/identity-reviews/review-page"

const IdentityReviewRoute = () => (
  <IdentityReviewPage detail={Route.useLoaderData()} />
)

export const Route = createFileRoute(
  "/_terminalAdmin/terminal/admin/identity-reviews/$identityReviewId"
)({
  loader: ({ params: { identityReviewId } }) =>
    loadIdentityReview({ data: { identityReviewId } }),
  component: IdentityReviewRoute,
})
